import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Pagemaster, PagemasterData } from '../../../interfaces/masters/pagemaster';
import { PagemasterApi } from '../api/pagemaster.api';

@Injectable()
export class PageMasterService extends  PagemasterData{

  constructor(private api: PagemasterApi) { 
    super();
  }
  
  list(): Observable<Pagemaster[]> {
    return this.api.list();
  }

  getPageListByModuleId(url: string): Observable<Pagemaster[]> {
    return this.api.getPageListByModuleId(url);
  }
  getById(url:string): Observable<Pagemaster>{
      return this.api.getById(url);
  }

  create(url: string, data:Pagemaster): Observable<Pagemaster> {
    return this.api.add(url,data);
  }

  update(url: string, data:Pagemaster): Observable<Pagemaster> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
